import { render, staticRenderFns } from "./comment_section.vue?vue&type=template&id=7402d23d&scoped=true"
import script from "./comment_section.vue?vue&type=script&lang=js"
export * from "./comment_section.vue?vue&type=script&lang=js"
import style0 from "./comment_section.vue?vue&type=style&index=0&id=7402d23d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7402d23d",
  null
  
)

export default component.exports